import * as queryString from 'query-string';

export const formatRegistrationCampaign = (thirdPartyCompanyId) => {
    if (thirdPartyCompanyId) {
        return `Engage-${thirdPartyCompanyId}`;
    }
    return null;
};

export const getThirdPartyCompanyIdFromUrl = (url) => {
    if (!url) {
        return null;
    }

    const { return: returnUrlParam } = queryString.parse(url);

    if (!returnUrlParam) {
        return null;
    }

    const returnUrl = new URL(returnUrlParam, window.location.href);

    if (returnUrl.pathname !== '/oauth') {
        return null;
    }

    const { third_party_company_id: thirdPartyCompanyId } = queryString.parse(returnUrl.search);

    return thirdPartyCompanyId || null;
};

export const hasRequiredEngageOAuthParams = (location) => {
    const { pathname, search = '' } = location;
    if (pathname !== '/oauth') {
        return false;
    }
    const params = queryString.parse(search);
    const requiredParams = [
        'client_id',
        'redirect_uri',
        'approval_prompt',
        'scope',
        'third_party_company_id',
        'token',
    ];
    return requiredParams.every((key) => params[key]);
};

export const MEMBER_DECLINED_AUTHORIZATION_ERROR = 'MemberDeclinedAuthorization';

export const buildDeclineRedirectUrl = (redirectUri, urlState) => {
    const separator = redirectUri.includes('?') ? '&' : '?';
    const declineUrl = `${redirectUri}${separator}error=${MEMBER_DECLINED_AUTHORIZATION_ERROR}`;

    if (!urlState) {
        return declineUrl;
    }

    return `${declineUrl}&state=${encodeURIComponent(urlState)}`;
};

export const linkedAccountTypes = {
    TENNIS_AUSTRALIA: 'Tennis Australia',
    APPLE: 'Apple',
    FACEBOOK: 'Facebook',
};
